(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector/assets/javascripts/draw-item.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector/assets/javascripts/draw-item.js');
'use strict';

const {
  useMemo,
  useCallback,
  forwardRef
} = React;
const {
  Card,
  CardBody,
  CardFooter
} = svs.ui.ReactCard;
const {
  getGameUrl
} = svs.components.lbUtils;
const {
  DrawState
} = svs.components.sport.tipsenShared;
const {
  DrawClosed
} = svs.components.tipsen.drawselector;
const {
  useComponentFromRegistry
} = svs.components.tipsen.componentRegistry;

const DrawItem = forwardRef((_ref, ref) => {
  let {
    draw,
    onLinkKeyDown,
    onTriggerRoute,
    index,
    isCentered,
    isDisabled,
    isLargeDevice,
    isSelected,
    setCenteredIndex,
    setSelectedIndex
  } = _ref;
  const {
    drawStateId,
    drawState,
    drawNumber,
    productId
  } = draw;
  const isOpened = drawStateId === DrawState.Opened;
  const isExpanded = isLargeDevice && isSelected;
  const classListForDrawItemWrapper = useMemo(() => {
    const classList = ['draw-item-wrapper', "draw-number-".concat(drawNumber)];
    isCentered && classList.push('draw-item-wrapper-centered');
    isSelected && classList.push('draw-item-wrapper-selected');
    isSelected && isLargeDevice && classList.push('draw-item-wrapper-expanded');
    isDisabled && classList.push('draw-item-wrapper-inactive');
    drawState && classList.push(drawState.toLowerCase());
    return classList.join(' ');
  }, [drawNumber, isCentered, isSelected, isLargeDevice, isDisabled, drawState]);
  const drawUrl = getGameUrl({
    productId,
    drawNumber
  });
  const onCardClick = useCallback(e => {
    e.preventDefault();
    if (isDisabled || isSelected) {
      return;
    }
    onTriggerRoute(productId, drawNumber);
  }, [drawNumber, isSelected, productId, onTriggerRoute, isDisabled]);
  const onKeyDown = useCallback(e => {
    if (!isDisabled) {
      onLinkKeyDown(e, productId, drawNumber);
    }
  }, [drawNumber, isDisabled, onLinkKeyDown, productId]);
  const preventRightClick = useCallback(event => {
    const LEFT_MOUSE_BUTTON = 1;
    if (event.button !== LEFT_MOUSE_BUTTON) {
      event.preventDefault();
    }
  }, []);
  const onFocus = useCallback(() => {
    if (!isDisabled) {
      setCenteredIndex(index);
    }
  }, [index, setCenteredIndex, isDisabled]);
  const onSelect = useCallback(() => {
    if (!isDisabled) {
      setSelectedIndex(index);
    }
  }, [setSelectedIndex, index, isDisabled]);
  const DrawPanelContent = useComponentFromRegistry('draw-panel-content');
  if (!draw) {
    return null;
  }
  return React.createElement("div", {
    className: classListForDrawItemWrapper,
    key: drawNumber,
    onFocus: onFocus,
    ref: ref
  }, React.createElement(DrawClosed, {
    drawNumber: drawNumber,
    isCollapsed: !isExpanded,
    productId: productId
  }), React.createElement(Card, {
    branding: "sport",
    Component: isDisabled ? 'div' : 'a',
    href: drawUrl,
    key: drawNumber,
    onClick: onCardClick,
    onKeyDown: onKeyDown,
    onMouseDown: preventRightClick,
    tabIndex: isCentered && !isDisabled ? 0 : -1
  }, React.createElement(CardBody, null, React.createElement("div", {
    className: "draw-item",
    onClick: onSelect
  }, React.createElement(DrawPanelContent, {
    draw: draw,
    isExpanded: isExpanded,
    isLargeDevice: isLargeDevice,
    isOpened: isOpened,
    isSelected: isSelected
  }))), React.createElement(CardFooter, null)));
});
setGlobal('svs.components.tipsen.drawselector.DrawItem', DrawItem);

 })(window);